class ApiHelper {

    GetUrlWithCurrentDomain(constUrlPart)
    {
        return this.GetRootUrlWithCurrentDomain() + "/"+constUrlPart;
    }

    GetRootUrlWithCurrentDomain()
    {
        return window.location.protocol+"//"+window.location.hostname;
    }
}

export default new ApiHelper();